import { render, staticRenderFns } from "./DataTableV2ImportResult.html?vue&type=template&id=5a0659fc&external"
import script from "./DataTableV2ImportResult.js?vue&type=script&lang=js&external"
export * from "./DataTableV2ImportResult.js?vue&type=script&lang=js&external"
import style0 from "./DataTableV2ImportResult.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
